<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <letting-translation-control [control]="form.controls['phrase']" type="box" requiredCulture="sv-SE"></letting-translation-control>
          <astral-toggle [control]="form.controls['isActive']"></astral-toggle>
        </astral-layout-group>
      </section>
    </form>

    @if (!isNew) {
      <section class="letting-feature-usage astral-content-width" aria-labelledby="letting-feature-usage-heading">
        <div class="letting-feature-usage__overview">
          <app-information-block [text]="'LETTING_FEATURE.USAGE_INFORMATION' | translate"></app-information-block>
          <section class="astral-section-surface letting-feature-usage__summary" aria-live="polite">
            <h3 id="letting-feature-usage-heading">{{ 'LETTING_FEATURE.USAGE_HEADER' | translate }}</h3>

            @if (usageSummaryLoading) {
              <app-information-block [text]="'LETTING_FEATURE.USAGE_LOADING' | translate"></app-information-block>
            } @else if (usageSummaryFailed) {
              <div class="astral-stack-m">
                <app-information-block [text]="'LETTING_FEATURE.USAGE_LOAD_FAILED' | translate"></app-information-block>
                <astral-button
                  variant="secondary"
                  size="small"
                  type="button"
                  labelKey="COMMON.TRY_AGAIN"
                  (click)="loadUsageSummary()"
                ></astral-button>
              </div>
            } @else {
              <div class="letting-feature-usage__category-grid">
                @for (item of usageCategories; track item.category) {
                  <div class="letting-feature-usage__category">
                    <span class="letting-feature-usage__category-chart" [style.--usage-share]="usageShare(item.category)">
                      <i [class]="item.iconClass" aria-hidden="true"></i>
                    </span>
                    <span>
                      <strong>{{ item.labelKey | translate }}</strong>
                      <span>{{ usageCount(item.category) }} {{ 'LETTING_FEATURE.USAGE_COUNT_SUFFIX' | translate }}</span>
                    </span>
                  </div>
                }
              </div>
            }
          </section>
        </div>

        <div class="astral-accordion-stack">
          @for (item of usageCategories; track item.category) {
            <astral-accordion
              [header]="item.labelKey"
              [counter]="usageCount(item.category)"
              [allowWidthExpansion]="true"
              (stateChanged)="onUsageAccordionStateChanged(item.category, $event)"
            >
              <div aria-live="polite">
                @if (usageLoadingCategories.has(item.category)) {
                  <app-information-block [text]="'LETTING_FEATURE.USAGE_OBJECTS_LOADING' | translate"></app-information-block>
                } @else if (usageFailedCategories.has(item.category)) {
                  <div class="astral-stack-m">
                    <app-information-block [text]="'LETTING_FEATURE.USAGE_OBJECTS_LOAD_FAILED' | translate"></app-information-block>
                    <astral-button
                      variant="secondary"
                      size="small"
                      type="button"
                      labelKey="COMMON.TRY_AGAIN"
                      (click)="loadUsage(item.category)"
                    ></astral-button>
                  </div>
                } @else if (usageLoadedCategories.has(item.category)) {
                  @if (usageByCategory[item.category]?.length) {
                    <div class="letting-feature-usage__table-scroll">
                      <table class="letting-feature-usage__table">
                        <thead>
                          <tr>
                            <th scope="col">{{ 'RENTAL_OBJECT_FORM.RENTAL_OBJECT_NUMBER_LABEL' | translate }}</th>
                            <th scope="col">{{ 'LETTING_FEATURE.USAGE_STREET' | translate }}</th>
                            <th scope="col">{{ 'LETTING_FEATURE.USAGE_INCLUDED' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (rentalObject of usageByCategory[item.category]; track rentalObject.id) {
                            <tr>
                              <td>{{ rentalObject.rentalId || '–' }}</td>
                              <td>{{ rentalObject.street || '–' }}</td>
                              <td>{{ (rentalObject.isIncluded ? 'YES_TEXT' : 'NO_TEXT') | translate }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  } @else {
                    <app-information-block [text]="'LETTING_FEATURE.USAGE_EMPTY' | translate"></app-information-block>
                  }
                }
              </div>
            </astral-accordion>
          }
        </div>
      </section>
    }
  }
</section>
